import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  FeaturesComponent,
  ClientsComponent,
  KnowledgeComponent,
  PotencialClientsComponent,
  SurveyComponent,
  ClientDetailComponent,

} from '.';
import { ClientUsersComponent } from './details/client-users/client-users.component';
import { ClientFeaturesComponent } from './details/client-features/client-features.component';
import { ClientPermissionsComponent } from './details/client-permissions/client-permissions.component';
import { ClientFeatureSwitchComponent } from './details/client-features/client-feature-switch/client-feature-switch.component';
import { ClientDetailsNavigationComponent } from './details/client-details-navigation/client-details-navigation.component';
import { ClientUserComponent } from './details/client-users/client-user/client-user.component';
function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  { path: 'clients', component: ClientsComponent, canActivate: [AuthGuard] },
  { path: 'clients/:ID', component: ClientDetailComponent, canActivate: [AuthGuard] },
  { path: 'clients/:ID/Users', component: ClientUsersComponent, canActivate: [AuthGuard] },
  { path: 'clients/:ID/User/:UserID', component: ClientUserComponent, canActivate: [AuthGuard] },
  { path: 'clients/:ID/Features', component: ClientFeaturesComponent, canActivate: [AuthGuard] },
  { path: 'clients/:ID/Permissions', component: ClientPermissionsComponent, canActivate: [AuthGuard] },
  { path: 'clients/potencial', component: PotencialClientsComponent, canActivate: [AuthGuard] },
  { path: 'clients/Survey', component: SurveyComponent, canActivate: [AuthGuard] },
  { path: 'knowledge', component: KnowledgeComponent, canActivate: [AuthGuard] },
  { path: 'features', component: FeaturesComponent, canActivate: [AuthGuard] },
];

const pages = [
  FeaturesComponent,
  ClientsComponent,
  KnowledgeComponent,
  PotencialClientsComponent,
  SurveyComponent,
  ClientDetailComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeWrapperModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages,
    ClientUsersComponent,
    ClientFeaturesComponent,
    ClientPermissionsComponent,
    ClientFeatureSwitchComponent,
    ClientDetailsNavigationComponent,
    ClientUserComponent
  ],
  providers: []
})
export class ClientsModule { 
  constructor(@Optional() @SkipSelf() parentModule: ClientsModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
